var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prj-header"},[_vm._t("pre",function(){return [_c('div')]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }